import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Container,
  Typography,
  CircularProgress,
  Box,
  Paper,
  Button
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../../Sidebar/DashboardLayout';
import GenericTable from '../../../commun/GenericTable';
import ActionButtons from '../../../commun/ActionButtons';
import { showDeleteConfirmation } from '../../../commun/deletemsg';
import Pagination from '../../../commun/Pagination';
import './notificationTemplates.css';
import Chatbox from '../../../commun/ChatBox';

const NotificationTemplatesAdmin = () => {
  const [page, setPage] = useState(1);
  const [displayMode, setDisplayMode] = useState('table');
  const [templates, setTemplates] = useState([]);
  const templatesPerPage = 10;
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const userRole = localStorage.getItem('userType');
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = async () => {
    setLoading(true);
     try {
      const token = localStorage.getItem('authToken'); // or sessionStorage, or context, depending on how your app handles auth

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/notification-templates/with-usage`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setTemplates(res.data);
    }catch (error) {
      console.error('Erreur chargement templates :', error.message);
      setTemplates([]);
    } finally {
      setLoading(false);
    }
  };  

  const handleDelete = (id) => {
    showDeleteConfirmation({
      onConfirm: async () => {
        try {
          await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/admin/notification-templates/${id}`);
          fetchTemplates();
        } catch (error) {
          console.error('Erreur suppression :', error.message);
        }
      }
    });
  };

  const columns = [
    { key: 'key', label: 'Clé' },
    { key: 'type', label: 'Type' },
    { key: 'message', label: 'Message', render: (val) => val.length > 60 ? val.substring(0, 60) + '...' : val }
  ];

  const paginatedTemplates = templates.slice((page - 1) * templatesPerPage, page * templatesPerPage);

  const renderActions = (row) => (
    <ActionButtons
      showView={false}
      onEdit={() => navigate(`/admin/notification-templates/edit/${row._id}`)}
      onDelete={row.usedInCode ? null : () => handleDelete(row._id)}
    />
  );

  return (
    <DashboardLayout>
      <Container maxWidth="lg">
        <Box className="notification-templates-header">
          <Typography variant="h4" className="notification-templates-title">
            Modèles de notifications
          </Typography>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => navigate('/admin/notification-templates/new')}
          >
            Ajouter un modèle
          </Button>
        </Box>

        {loading ? (
          <Box display="flex" justifyContent="center" mt={4}>
            <CircularProgress />
          </Box>
        ) : (
                    <>
          <Paper elevation={1} className="notification-table">
            <GenericTable
              columns={columns}
              data={paginatedTemplates}
              renderActions={renderActions}
              displayMode={displayMode}
              setDisplayMode={setDisplayMode}
              totalItems={templates.length}
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
            />
            <Pagination
              page={page}
              setPage={setPage}
              totalItems={templates.length}
              itemsPerPage={templatesPerPage}
            />
          </Paper>
          </>
        )}
      </Container>
      {userRole !== 'agent' && <Chatbox userRole={userRole} />}
    </DashboardLayout>
  );
};

export default NotificationTemplatesAdmin;
